/**
 * Codable — widget-first ModuleWorkspace.
 * Záložky: Projekty | Knihovna | Nastavení.
 * Per-projekt (varianta, backend, git) = workspace gear.
 * Sub-routes new / :id zůstávají; /library a /settings mapují na tab.
 */
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { useIsPhoneLayout } from '../../lib/ui-layout';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('codable');

export default function CodablePage() {
  const isPhone = useIsPhoneLayout();
  const location = useLocation();
  const [params] = useSearchParams();
  const tab = params.get('tab');
  const onSettingsPath = /\/modules\/codable\/settings\/?$/.test(location.pathname);
  const onLibraryPath = /\/modules\/codable\/library\/?$/.test(location.pathname);

  if (isPhone) {
    const phoneTab = onSettingsPath || tab === 'settings' || tab === 'members'
      ? 'settings'
      : (onLibraryPath || tab === 'library' || tab === 'templates')
      ? 'library'
      : tab === 'new'
      ? 'new'
      : 'projects';
    return <Navigate to={`/phone/codable?tab=${phoneTab}`} replace />;
  }

  const defaultTab = onSettingsPath || tab === 'settings' || tab === 'members'
    ? 'settings'
    : onLibraryPath || tab === 'library' || tab === 'templates'
    ? 'library'
    : 'projects';
  return <ModuleWorkspace def={DEF} defaultTab={defaultTab} />;
}
